<script setup lang="ts">
  import { useGIDataUploadCollectionStore } from '@/stores/giDataUploadCollection'
  import GenericDialog from '@/components/dialog/GenericDialog.vue'

  import { ref } from 'vue'
  import { storeToRefs } from 'pinia'
  import ChoiceField from '@/components/form/ChoiceField.vue'

  const giDataUploadCollectionStore = useGIDataUploadCollectionStore()
  const { items, loading } = storeToRefs(giDataUploadCollectionStore)
  const geologyCodeChoices = ref(['GeologyCode', 'GeologyCode2'])
  const store = useGIDataUploadCollectionStore()
</script>

<template>
  <GenericDialog
    :model-value="store.showClassificationUploadDialog"
    :max-width="600"
    @clickedOutside="store.toggleClassificationUploadDialog"
  >
    <template #title> Upload classification data </template>
    <template #default>
      <ChoiceField
        v-model="giDataUploadCollectionStore.selectedGICollectionForUploadClassification"
        label="GI Data Upload Collection"
        :selectable-item="items"
        item-title="name"
        item-value="id"
        :clearable="false"
      />
      <ChoiceField
        v-model="giDataUploadCollectionStore.selectedClasssificationColumnName"
        label="Geology Code"
        :clearable="false"
        :selectable-item="geologyCodeChoices"
      />
      <v-file-input
        v-model="giDataUploadCollectionStore.selectedFile"
        label="Upload Excel File"
        accept=".xlsx,.xls,.xlsm"
      />
    </template>
    <template #actions>
      <v-btn
        variant="text"
        color="primary"
        @click="giDataUploadCollectionStore.toggleClassificationUploadDialog"
      >
        Cancel
      </v-btn>
      <v-btn
        variant="text"
        color="primary"
        :loading="loading"
        :disabled="!giDataUploadCollectionStore.canUploadClassification"
        @click="giDataUploadCollectionStore.uploadClassificationFile"
      >
        Upload
      </v-btn>
    </template>
    <template #additional-actions>
      <v-btn
        variant="text"
        color="primary"
        @click="giDataUploadCollectionStore.downloadClassificationUploadTemplate"
        :disabled="!giDataUploadCollectionStore.canDownloadTemplate"
      >
        Download Template
      </v-btn>
    </template>
  </GenericDialog>
</template>
